import {
  Box,
  Container,
  Divider,
  Link,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useAppSelector } from "../../../redux/store";
import GetFooterLinkLabels from "../../../utils/getFooterLinksLabel";

export const footerLinks = [
  {
    label: "Terms of Use",
    link: "https://www.britishcouncil.org/terms",
    value: "termsOfUse",
  },
  {
    label: "Accessibility",
    link: "https://www.britishcouncil.org/accessibility",
    value: "accesibility",
  },
  {
    label: "Privacy and Cookies",
    link: "https://www.britishcouncil.org/privacy-cookies?_ga=2.226228574.599152170.1691482899-865719005.1690202203&_gl=1*12ae16t*_ga*ODY1NzE5MDA1LjE2OTAyMDIyMDM.*_ga_X5M3D7HLQQ*MTY5MTU3NjkyMC4xMy4xLjE2OTE1Nzc0MjIuNDguMC4w*_ga_L7H71GL81V*MTY5MTU3NjkyMC4xMy4xLjE2OTE1NzY5MjIuNTguMC4w",
    value: "privacy",
  },
  {
    label: "Data Protection",
    link: "https://www.britishcouncil.org/privacy-cookies/data-protection",
    value: "protection",
  },
];

const Footer = () => {
  const theme = useTheme();
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText }: any = customerJourney;
  const linkLabels = GetFooterLinkLabels();

  return (
    <Box component="footer">
      <Box sx={{ background: "linear-gradient(90deg, #E3FDF5 0%, #FFF 100%)" }}>
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            height: { xs: "100px", md: "160px" },
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            display={{ xs: "none", md: "flex" }}
          >
            <Box
              sx={{
                fontSize: "1.5rem",
                fontWeight: "300",
                color: "common.black",
                width: "174px",
                fontFamily: "system-ui",
              }}
            >
              {pageText?.textMetadata.learnWithTheBritishCouncil}
            </Box>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="120"
              height="120"
              viewBox="0 0 120 120"
              fill="none"
            >
              <path
                d="M45 90L75 60L45 30"
                stroke={theme.palette.primary.light}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Stack>
          <Link
            href="https://www.britishcouncil.org/exam/global-exams-services/uk-boards-overseas"
            sx={{
              fontWeight: "700",
              fontFamily: "Arial,sans-serif",
              color: "primary.light",
              opacity: "0.8",
              textDecoration: "underline",
              display: "flex",
              gap: "4px",
              alignItems: "center",
              "&:hover": {
                opacity: "1",
              },
            }}
          >
            {pageText?.textMetadata.aboutCambridgeEsolExamRegistration}
            <Box>
              <img src="/assets/svg/external-link.svg" alt="logo" />
            </Box>
          </Link>
        </Container>
      </Box>
      <Box bgcolor="secondary.main" py={6}>
        <Container maxWidth="xl">
          <Stack
            direction={{ xs: "column", md: "row" }}
            divider={<Divider orientation="vertical" flexItem color="#fff" />}
            spacing={{ xs: 0, md: 4 }}
            marginBottom={4}
          >
            {footerLinks.map((item) => (
              <Link
                key={item.label}
                href={item.link}
                color="common.white"
                padding="5px 0"
                fontWeight="700"
                underline="hover"
                fontFamily="Arial"
              >
                {linkLabels[item.value]}
              </Link>
            ))}
          </Stack>

          <Typography color="common.white">
            {pageText?.textMetadata.britishCouncilCopyright} <br />
            {pageText?.textMetadata.footerLine1}
            <br />
            {pageText?.textMetadata.footerLine2}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
